import { useEffect } from "react";
import StaffDailyReports from "./components/staffDailyReports";
import StaffWeeklyReports from "./components/staffWeeklyReports";
import StaffAnnuallyReport from "./components/staffAnnuallyReport";
import { IStaffReports } from "../../../models/dashboard/staffReports/staffReports";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { getSnapShots } from "../../../action/masters/snapShotActionCreator";
import { setSnapShots } from "../../../store/slices/master/snapShotSlice";
import { getPageBlockData } from "../../../common-functions/commonFunctions";
import { pageBlockId } from "../../../constants/pageBlocks";

const StaffReports = (props: IStaffReports) => {
  const { getSnapShots } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getSnapShots();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSnapShots([]));
    };
  }, []);

  return (
    <>
      <div className="report-wrap stafreport-mobile">
        <div className="row">
            <StaffDailyReports/>
            <StaffWeeklyReports/>
            <StaffAnnuallyReport/>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getSnapShots: () => getSnapShots(),
};


export default connect(null, mapDispatchToProps)(StaffReports);
